import { Col, Container, Row } from "reactstrap";
import BecomeMember from "./BecomeMember";
import SimplePricingCard from "./SimplePricingCard";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ECommerce, Pricing } from "../../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";

const PricingContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Pricing} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <BecomeMember />
            <SimplePricingCard />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default PricingContainer;
